import { map } from 'rxjs/operators';
import { isDisenrolled$ } from '../services/subjects';
import { combineLatest, Observable } from 'rxjs';

export const enrolledOnly = <T extends any[]>(
    observable$: Observable<T>
  ): Observable<T> => {
    return combineLatest([isDisenrolled$, observable$]).pipe(
      map(([isDisenrolled, results]) => (isDisenrolled ? ([] as T) : results))
    );
  };
  